// @ts-check

/**
 * Extracts the component name from the file name.
 *
 * @param {string} fileName
 * @returns {string}
 *
 * @example
 * extractComponentName("SpButton.ce.vue") // "SpButton"
 * extractComponentName("SpTextField.ce.vue") // "SpTextField"
 */
export function extractComponentName(fileName) {
  return fileName.replace(".ce.vue", "");
}

/**
 * Enriches the component props with the props passed to the custom element.
 *
 * @param {import("vue").DefineComponent} component
 * @param {string} fileName
 * @param {import("vue").ComponentObjectPropsOptions} props
 * @returns {import("vue").ComponentObjectPropsOptions}
 */
export function enrichProps(component, fileName, props) {
  const componentName = extractComponentName(fileName);
  const defaultGlobalProps = props.global ?? {};
  const defaultProps = props[componentName] ?? defaultGlobalProps;

  /**
   * @param {import("vue").ComponentObjectPropsOptions} acc
   * @param {[string, import("vue").Prop<unknown>]} entry
   * @returns {import("vue").ComponentObjectPropsOptions}
   */
  const reducer = (acc, [key, value]) => {
    const defaultPropsValue = props[key] ?? defaultProps[key];

    if (defaultPropsValue !== undefined) {
      value = {
        ...value,
        required: false,
        default: defaultPropsValue,
      };
    }

    return { ...acc, [key]: value };
  };

  return Object.entries(component.props ?? {}).reduce(reducer, {});
}
